/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
let config = [
    {
        name : "Script Execution Duration Trend (in milliseconds)",
        signal_type : "EXEC_DURATION",
        width : '100%',
        entity_id : "id",
        entity_name : "Scripts",
        charts : [
            {
                type : 'area',
                name : 'Statistics',
                param_key : null,
                param_value : null,
                value_key : 'value',
                color : 3
            }
        ]
    },
    {
        name : "Script Status Trend",
        signal_type : "EXEC_STATUS",
        width : '50%',
        entity_id : "id",
        entity_name : "Scripts",
        charts : [
            {
                type : 'area',
                name : 'Completed',
                param_key : 'status',
                param_value : 'Completed',
                value_key : 'value',
                color : 3
            },
            {
                type : 'area',
                name : 'Aborted',
                param_key : 'status',
                param_value : 'Aborted',
                value_key : 'value',
                color : 4
            }
        ]
    },
    {
        name : "Script Invocation Trend",
        signal_type : "INVOKE_FREQ",
        width : '50%',
        entity_id : "id",
        entity_name : "Scripts",
        charts : [
            {
                type : 'area',
                name : 'Invocation Frequency',
                param_key : null,
                param_value : null,
                value_key : 'value',
                color : 3
            },
        ]
    }
]

export default config